<template>
  <div class="collapse-group">
    <slot/>
  </div>
</template>
<script>
export default {
  props: {
    accordion: {
      type: Boolean,
      require: true,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/collapse/VCollapse.vue